import React, {useLayoutEffect} from 'react'
import { useLoader } from '@react-three/fiber'
import * as THREE from "three"
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import model from "../../../Assets/Sign Board/SignBoard.fbx"
import aoTex from "../../../Assets/Sign Board/aoTex.jpg"
import tex from "../../../Assets/Sign Board/tex.jpg"
// import normalTex from "../../../Assets/Door/glass_normal.png" 
import { useTexture, useCubeTexture } from '@react-three/drei'

const Sign = ({size}) => {

    const [aoMap, map] = useTexture([aoTex, tex]);
    aoMap.flipY = false
    // aoMap.encoding = THREE.RGBFormat
    // aoMap.offset.set(-0.1, 0.1)
    map.encoding = THREE.RGBFormat

    const envMap = useCubeTexture(['Right.jpg', 'Left.jpg', 'Top.jpg', 'Bottom.jpg', 'Front.jpg', 'Back.jpg'], { path: 'Cube/type1-center/' })

    const material = React.useMemo(() => new THREE.MeshPhongMaterial({
     map: map,
    //  aoMap : aoMap,
    //  aoMapIntensity:-1,
     emissiveMap : map,
     emissive : "#000000",
     emissiveIntensity : 0.7,
     color : "#A0A0A0",
    }), [])

    const fbx = useLoader(FBXLoader, model)
    useLayoutEffect(() => {
        fbx.traverse(function(child){
            if(child.isMesh){
                child.material = material
            }
        })
    }, [])

    return (
        <primitive
            object={fbx} 
            position={[-(size+48)/2, 4, 0]} 
            rotation={[0, Math.PI, 0]}
            // scale={[0.5, 0.5, 0.5]}
        />
    )
}

export default Sign
